import React from 'react';

import ProfileForm from 'Shared/components/ProfileForm/ProfileForm';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

function ProfilePage() {
  const { user } = useCurrentUser();
  return (
    <div className="profile-page">
      <ProfileForm user={user} />
    </div>
  );
}

export default ProfilePage;
